export default "{\n    \"showMoreLabel\": \"Show More\"\n}\n"